import { render, staticRenderFns } from "./PostponeAudit.vue?vue&type=template&id=7fa4b052&scoped=true&"
import script from "./PostponeAudit.vue?vue&type=script&lang=ts&"
export * from "./PostponeAudit.vue?vue&type=script&lang=ts&"
import style0 from "./PostponeAudit.vue?vue&type=style&index=0&id=7fa4b052&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa4b052",
  null
  
)

export default component.exports